<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <reports>
        </reports> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import Reports from './todo-reports'
export default {
    components: {
        Reports
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-reports/base-reports.vue